import React, { useState, useRef, useEffect } from "react";
import QRCode from "qrcode";
import apsandlogo from "../assets/apsandlogo.png";
import { useReactToPrint } from "react-to-print";
import "./styles.css";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

function JSCompiler() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  let dispatchTime = d.toLocaleString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  })
  .replace("am", "AM")
  .replace("pm", "PM");
  const [form, setForm] = useState({
    orderid: "",
    tripno: "",
    customername: "",
    customermobile: "",
    sandquantity: "",
    sandsupplypoint: "",
    dispatchdate: "",
    drivername: "",
    drivermobile: "",
    vehicleno: "",
    address: "",
    registrationId: "",
    constructionName: "",
    registrationDate: "",
    registrationType: "",
    registrationQty: "",
    availableSandQty: "",
    eligibleSandQty: "",
    dispatchId: "",
    dispatchTime: dispatchTime,
  });

  const formatDispatchDateTime = () => {
    // if (!form.dispatchdate) return "";
  
    const dateObj = new Date(`${form.dispatchdate}T00:00:00`);
  
    const formattedDate = dateObj.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour12: true,

    });
    const [year, month, day] = form.dispatchdate.split("-");

    const formattedDate1 = `${day}-${month}-${year}`;

    
  console.log(`${formattedDate} ${form.dispatchTime}`,"")
    return form.dispatchdate ? `${formattedDate1} ${form.dispatchTime}` : `${form.dispatchTime}`;
  };
  

  const [qrImage, setQrImage] = useState("");
  const [showReceipt, setShowReceipt] = useState(false);

  const receiptRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // numeric-only fields
    const numericFields = ["tripno", "customermobile", "drivermobile"];

    if (numericFields.includes(name)) {
      // allow only digits
      if (!/^\d*$/.test(value)) return;
    }

    setForm({ ...form, [name]: value });
  };

  const generateQRCode = async () => {
    try {
      const encoded = btoa(JSON.stringify(form));
      // const docRef = await addDoc(collection(db, "deliveries"), {
      //   ...form,             // <-- your complete JSON object
      //   createdAt: new Date()
      // });

      const docRef = await addDoc(collection(db, "deliveries"), {
        ...form,
        createdAt: new Date(),
      }).catch((err) => {
        console.error("Firestore write FAILED:", err);
      });

      // 2. Get Firestore auto-generated ID
      const id = docRef.id;

      // 3. Create URL for the QR code
      // const url = `http://localhost:3000/view?id=${id}`;

      const url = `https://apsandmanagement.in/view?id=${id}`;

      console.log("Generated URL:", url);

      // 4. Generate QR code
      const qr = await QRCode.toDataURL(url);

      setQrImage(qr);
      setShowReceipt(true);

      return true;
    } catch (err) {
      console.error("Firestore error:", err);
      alert("Error: " + err.message);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
  });

  // const handleGenerateAndPrint = async () => {
  //   await generateQRCode(); // sets QR code
  //   window.print();
  //   // await generateQRCode(); // sets QR code
  //   // // Wait for DOM to update with new QR
  //   // setTimeout(() => {
  //   //   if (receiptRef.current) {
  //   //     handlePrint(); // now guaranteed to exist
  //   //   }
  //   // }, 0);
  // };

  useEffect(() => {
    if (!qrImage) return;

    const img = document.querySelector(".qr-image");

    if (img) {
      if (img.complete) {
        window.print();
      } else {
        img.onload = () => window.print();
      }
    }
  }, [qrImage]);

  const handleGenerateAndPrint = async () => {
    await generateQRCode(); // sets QR image and showReceipt = true

    // const qrImg = document.querySelector(".qr-image");
    // if (qrImg) {
    //   if (qrImg.complete) {
    //     window.print();
    //   } else {
    //     qrImg.onload = () => window.print();
    //   }
    // }

    // else {
    //   window.print();
    // }
  };

  useEffect(() => {
    // setForm((prev) => ({
    //   ...prev,
    //   dispatchTime: new Date().toLocaleTimeString(),
    // }));
  }, []);

  // useEffect(() => {
  //   if (showReceipt && receiptRef.current) {
  //     handlePrint();
  //   }
  // }, [showReceipt, handlePrint]);

  return (
    <div className="wrapper">
      <div className="card">
        <h2>Generate Delivery QR Code</h2>

        {/* Form Fields */}
        {/* <div className="two-col">
          <div>
            
          </div>
         
        </div> */}
        <label>Order ID</label>
        <input name="orderid" value={form.orderid} onChange={handleChange} />

        <label>Trip No</label>
        <input name="tripno" value={form.tripno} onChange={handleChange} />

        <label>Customer Name</label>
        <input
          name="customername"
          value={form.customername}
          onChange={handleChange}
        />

        <label>Customer Mobile</label>
        <input
          name="customermobile"
          value={form.customermobile}
          onChange={handleChange}
        />

        <label>Sand Quantity (Tons)</label>
        <input
          name="sandquantity"
          type="number"
          value={form.sandquantity}
          onChange={handleChange}
        />

        <label>Sand Supply Point</label>
        <input
          name="sandsupplypoint"
          value={form.sandsupplypoint}
          onChange={handleChange}
        />

        <label>Dispatch Date</label>
        <input
          type="date"
          name="dispatchdate"
          value={form.dispatchdate}
          onChange={handleChange}
        />

        <label>Driver Name</label>
        <input
          name="drivername"
          value={form.drivername}
          onChange={handleChange}
        />
        <label>Driver Mobile</label>
        <input
          name="drivermobile"
          value={form.drivermobile}
          onChange={handleChange}
        />
        <label>Vehicle Number</label>
        <input
          name="vehicleno"
          value={form.vehicleno}
          onChange={handleChange}
        />

        <label>Address</label>
        <textarea
          name="address"
          rows="3"
          value={form.address}
          onChange={handleChange}
          className="textarea"
        />

        {/* New Fields */}
        <label>Registration ID</label>
        <input
          name="registrationId"
          value={form.registrationId}
          onChange={handleChange}
        />

        <label>Construction Name</label>
        <input
          name="constructionName"
          value={form.constructionName}
          onChange={handleChange}
        />

        <label>Registration Date</label>
        <input
          type="date"
          name="registrationDate"
          value={form.registrationDate}
          onChange={handleChange}
        />

        <label>Registration Type</label>
        <input
          name="registrationType"
          value={form.registrationType}
          onChange={handleChange}
        />

        <label>Registration Qty</label>
        <input
          name="registrationQty"
          type="number"
          value={form.registrationQty}
          onChange={handleChange}
        />

        <label>Available Sand Qty</label>
        <input
          name="availableSandQty"
          type="number"
          value={form.availableSandQty}
          onChange={handleChange}
        />

        <label>Eligible Sand Qty</label>
        <input
          name="eligibleSandQty"
          type="number"
          value={form.eligibleSandQty}
          onChange={handleChange}
        />

        <label>Dispatch ID</label>
        <input
          name="dispatchId"
          value={form.dispatchId}
          onChange={handleChange}
        />

        <label>Dispatch Time</label>
        <input name="dispatchTime" value={form.dispatchTime} disabled />

        <button className="primary-btn" onClick={handleGenerateAndPrint}>
          Generate & Print
        </button>
      </div>

      {/* Receipt Container */}
      <div
        className="receipt-container"
        ref={receiptRef}
        // style={{ display: showReceipt ? "block" : "none" }}
      >
        {" "}
        <div className="receipt-block">
          {/* Consumer Copy */}
          <div className="receipt-header">
            <img src={apsandlogo} className="receipt-logo" alt="AP Sand Logo" />
            <div className="receipt-header-text">
              <div className="main-title">AP SAND</div>
              <div className="sub-title">MANAGEMENT SYSTEM</div>
            </div>
          </div>

          <div className="receipt-copy-label">Consumer Copy</div>
          <div className="receipt-divider"></div>

          <div className="receipt-row">
            <div className="receipt-label">Order Id</div>
            <div className="receipt-value">{form.orderid}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Trip No</div>
            <div className="receipt-value">{form.tripno}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Customer Name</div>
            <div className="receipt-value">{form.customername}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Customer Mobile No</div>
            <div className="receipt-value">{form.customermobile}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Sand Quantity:</div>
            <div className="receipt-value">{form.sandquantity} Tons</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Sand Supply Point Name</div>
            <div className="receipt-value">{form.sandsupplypoint}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Dispatch Date</div>
            <div className="receipt-value">
              {/* {form.dispatchdate} {form.dispatchTime} */}
              {formatDispatchDateTime()}

            </div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Driver Name</div>
            <div className="receipt-value">{form.drivername}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Driver Mobile No</div>
            <div className="receipt-value">{form.drivermobile}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Vehicle No</div>
            <div className="receipt-value">{form.vehicleno}</div>
          </div>
         <div className="receipt-address-center">
  {form.address && (() => {
    const parts = form.address.split(",").map(p => p.trim());

    return (
      <>
        {/* Line 1: Address + first value */}
        <div className="address-line-center">
          <span className="address-label">Address: </span>
          <span>{parts[0]},{parts[1]}</span>
        </div>

        {/* Line 2: next TWO values */}
        {parts.length > 3 && (
          <div className="address-line-center">
            {parts[2]}, {parts[3]},
          </div>
        )}

        {/* Remaining lines */}
        {parts.slice(4).map((line, index) => (
          <div key={index} className="address-line-center">
            {line}
          </div>
        ))}
      </>
    );
  })()}
</div>


          <div className="receipt-divider-two"></div>

          {/* Driver Copy */}
          <div className="receipt-header">
            <img src={apsandlogo} className="receipt-logo" alt="AP Sand Logo" />
            <div className="receipt-header-text">
              <div className="main-title">AP SAND</div>
              <div className="sub-title">MANAGEMENT SYSTEM</div>
            </div>
          </div>

          <div className="receipt-copy-label">Driver Copy</div>
          <div className="receipt-divider"></div>

          <div className="receipt-row">
            <div className="receipt-label">Order Id</div>
            <div className="receipt-value">{form.orderid}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Trip No</div>
            <div className="receipt-value">{form.tripno}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Customer Name</div>
            <div className="receipt-value">{form.customername}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Customer Mobile No</div>
            <div className="receipt-value">{form.customermobile}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Sand Quantity:</div>
            <div className="receipt-value">{form.sandquantity} Tons</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Sand Supply Point Name</div>
            <div className="receipt-value">{form.sandsupplypoint}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Dispatch Date</div>
            <div className="receipt-value">
              {/* {form.dispatchdate} {form.dispatchTime} */}
              {formatDispatchDateTime()}

            </div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Driver Name</div>
            <div className="receipt-value">{form.drivername}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Driver Mobile No</div>
            <div className="receipt-value">{form.drivermobile}</div>
          </div>
          <div className="receipt-row">
            <div className="receipt-label">Vehicle No</div>
            <div className="receipt-value">{form.vehicleno}</div>
          </div>
          <div className="receipt-address-center">
  {form.address && (() => {
    const parts = form.address.split(",").map(p => p.trim());

    return (
      <>
        {/* Line 1: Address + first value */}
        <div className="address-line-center">
          <span className="address-label">Address: </span>
          <span>{parts[0]},{parts[1]}</span>
        </div>

        {/* Line 2: next TWO values */}
        {parts.length > 3 && (
          <div className="address-line-center">
            {parts[2]}, {parts[3]},
          </div>
        )}

        {/* Remaining lines */}
        {parts.slice(4).map((line, index) => (
          <div key={index} className="address-line-center">
            {line}
          </div>
        ))}
      </>
    );
  })()}
</div>

          {/* <div className="receipt-address-block">
  <div className="receipt-address-label"></div>
  <div className="receipt-address-value">
  Address : {form.address}
  </div>
</div> */}
          {/* {qrImage && (
            <div className="qr-container">
              <img src={qrImage} className="qr-image" alt="QR Code" />
              <div className="thank-you-text">Thank You</div>
            </div>
          )} */}
          {qrImage && (
            <div className="qr-container">
              <img src={qrImage} className="qr-image" alt="QR Code" />

              {/* Sample Coordinates */}
              <div className="qr-coordinates">14.7638275, 78.0796343Thank You</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default JSCompiler;
